import LoanEdit from './LoanEdit';

export default LoanEdit;
